module.exports = __webpack_public_path__ + "img/whatsapp-optin.c0b156de.jpg";